<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="mat-typography">
  <p>{{ data.message }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.showSecondaryButton) {
    <button matButton mat-dialog-close>Cancel</button>
  }

  @if (data.showTertiaryButton) {
    <button matButton="tonal" (click)="onTertiaryButtonClick()">{{ data.tertiaryButtonLabel }}</button>
  }
  <button matButton="filled" [mat-dialog-close]="true" cdkFocusInitial>{{ data.buttonLabel }}</button>
</mat-dialog-actions>
